<template>
  <div
    v-if="loading"
    class="category-menu-loading"
  />
  <category-menu
    v-else
    :categories="categoriesMenu"
  />
</template>

<script>
import CategoryMenu from '@components/Category/CategoryMenu'
import { mapGetters } from 'vuex'
import * as types from '@store/types'

export default {
  components: { CategoryMenu },

  computed: {
    ...mapGetters({
      loading: types.CATEGORIES_LOADING,
      categoriesMenu: types.CATEGORIES_MENU
    })
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

.category-menu-loading {
  height: 60px;
  width: 100%;
  background: #eee;
  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
  border-radius: 5px;
  background-size: 200% 100%;
  animation: 1.5s shine linear infinite;
}
</style>



// WEBPACK FOOTER //
// src/containers/Category/CategoryMenu.vue